import angular from "angular";
import panel from "../services";

function profileEditMatch (panel) {

    return {
        restrict: 'E',
        scope: {
            pc: '='
        },
        link: function(scope) {

        },
        template: require('./templates/profile/edit-match.html')
    }
};

export default angular.module('directives.profileEditMatch', [panel]).directive('profileEditMatch', profileEditMatch).name;


// WEBPACK FOOTER //
// ./src/app/directives/profileEditMatch.js